import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { IRatingExteriorPayload, IRatingExteriorResponse } from 'src/app/model/ratings.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  public ratingSaved: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public overallChecker: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private http: HttpClient) {}

  getAllConditions(data: object) {
    return this.http.post(`${environment.api}/ratings/get/all-ratings-Conditions`, data);
  }

  getPartsCondition(data: any) {
    return this.http.post(`${environment.api}/ratings/get/parts-ratings`, data);
  }

  setPartsCondition(data: any) {
    return this.http.post(`${environment.api}/ratings/add/ratings`, data);
  }

  setRatingOverall(data: any) {
    return this.http.post(`${environment.api}/car/add/vehicle-grading`, data);
  }

  getRatingPartsData(data: object) {
    return this.http.post(`${environment.api}/ratings/get/ratings-Conditions`, data);
  }

  setRatingStates(data: object) {
    return this.http.post(`${environment.api}/ratings/add/ratings-states`, data);
  }

  deleteRatingStates(data: object) {
    return this.http.post(`${environment.api}/ratings/delete/ratings-states`, data);
  }

  deleteRatingImage(data: object) {
    return this.http.post(`${environment.api}/car/delete/images`, data);
  }

  getRatingStates(data: object) {
    return this.http.post(`${environment.api}/ratings/get/ratings-states`, data);
  }

  saveDocument(data: object) {
    return this.http.post(`${environment.api}/ratings/upload/documents`, data);
  }

  getDocument(data: object) {
    return this.http.post(`${environment.api}/ratings/get/documents`, data);
  }

  deleteDocument(data: object) {
    return this.http.post(`${environment.api}/ratings/delete/document`, data);
  }

  getQcConditions(payload: { vehicle_id: string; parent_part_id: string }) {
    const url = `${environment.api}/ratings/fetch-qc-conditions`;
    return this.http.post(url, payload).pipe(
      map((res: object) => {
        if (res?.['success'] && Array.isArray(res?.['data'])) {
          return res?.['data'].map((item: any) => ({
            ...item,
            parts_condition_name_en: item.part_condition?.parts_condition_name || '',
            parts_condition_name_ar: item.part_condition?.parts_condition_name_arabic || ''
          }));
        }
        return [];
      })
    );
  }

  getQcStatus() {
    const url = `${environment.api}/ratings/fetch-qc-statues`;

    return this.http.get(url).pipe(
      map((res: object) => {
        if (res?.['success'] && Array.isArray(res?.['data'])) {
          return res?.['data'].map((item: object) => ({
            ...item,
            name_en: item?.['name'],
            name_ar: item?.['name_arabic']
          }));
        }
        return [];
      })
    );
  }

  checkIfQcStatusExists(payload: { vehicle_id: string; parent_part_id: string }) {
    const url = `${environment.api}/ratings/vehicle-condition-review-statuses`;

    return this.http.post(url, payload).pipe(
      map((res: any) => {
        if (res?.success && Array.isArray(res.data)) {
          const validStatuses = res.data
            .filter((item: any) => item.qc_status_details != null)
            .map((item: any) => ({
              ...item.qc_status_details,
              condition_id: item.condition_id
            }));
          return validStatuses;
        }
        return [];
      })
    );
  }
  getRatingExteriorData(payload: IRatingExteriorPayload) {
    return this.http
      .post<IRatingExteriorResponse>(`${environment.api}/ratings/get/rating-exterior-data`, payload)
      .pipe(shareReplay());
  }
}
